import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HTTPService } from "src/app/services/http.service";
import { Agent } from "./agent.service";
import { P } from "@angular/cdk/keycodes";

export interface KnowledgeBase {
  id?:string;
  filePath: string;
  fileName: string;
  fileSize: number;
  correlationId?: string;
  mimeType?: string;
  
}

@Injectable({ providedIn: 'root' })
export class KnowledgeBaseService {

  constructor(private http: HTTPService ) {}

  /**
   * Documentos candidatos: gravados na propria KB com status "candidate", que
   * o searchKb nao recupera. Ficam guardados, invisiveis para o agente, ate
   * alguem aprovar.
   */
    getCandidatos(agent: Agent): Observable<any> {

        let filtro = {
            agentId: { "$oid": agent._id },
            status: "candidate"
        };

        let body = {
            "entityName": agent.kbTable,
            "useMongoManual": true,
            "type": "mongo",
            "dbName": agent.dbName,
            "maxRows": 300,
            "sql": JSON.stringify(filtro)
        };

        return this.http.postGeneric<any>(body, "JsonBrokerServices/findnative", false, true);
    }

    /** grava um texto como candidato, para revisao posterior */
    criarCandidato(agent: Agent, texto: string, sessionId: string): Promise<any> {

        return new Promise((resolve, reject) => {

            let body = {
                agent: agent._id,
                text: texto,
                sessionId: sessionId ?? ''
            };

            this.http.postGeneric<any>(body, "AiServices/kb/candidate", false, true).subscribe({
                next: (valor) => resolve(valor),
                error: (erro) => reject(erro)
            });
        });
    }

    /**
     * Aprova o candidato com o texto ja revisado.
     *
     * O Java apaga o rascunho e regrava: o texto costuma ser editado na revisao,
     * e o embedding do rascunho descreve o texto antigo.
     */
    aprovarCandidato(agent: Agent, correlationId: string, texto: string): Promise<any> {

        return new Promise((resolve, reject) => {

            let body = {
                agent: agent._id,
                correlationId: correlationId,
                text: texto
            };

            this.http.postGeneric<any>(body, "AiServices/kb/candidate/approve", false, true).subscribe({
                next: (valor) => resolve(valor),
                error: (erro) => reject(erro)
            });
        });
    }

    /** recusar e apagar os chunks daquele correlationId */
    recusarCandidato(agent: Agent, correlationId: string): Observable<any> {

        let body = {
            "entityName": agent.kbTable,
            "condition": `{"correlationId":"${correlationId}", "status":"candidate"}`,
            "useMongo": true,
            "dbName": agent.dbName
        };

        return this.http.post(body, 'JsonBrokerServices/remove', false, true, false, true);
    }

  /**
   * Lista arquivos da base de conhecimento
   */
    getKnowledgeBaseFiles(agent:Agent): Observable<any[]> {
        let body = {
            "entityName": agent.kbTable,
            "useMongo": true,
            "type": "mongodb",
            "mongoType": "aggregate",
            "sql":this.getQueryKB(agent),
            "dbName": agent.dbName
        }
        return this.http.postGeneric<any[]>(body, "JsonBrokerServices/findnative",false,true);
    }

    updateKnowledgeBase(agent: Agent, kb: KnowledgeBase): Promise<any> {

        return new Promise((resolve, reject) => {
            let body = {
                "agent":agent._id,
                "entityName": agent.kbTable,
                "kind": "manual",
                "file":{
                    "filePath": kb.filePath,
                    "fileName": kb.fileName,
                    "fileSize": kb.fileSize,
                    "mimeType": kb.mimeType
                },
                "version": new Date().getTime().toString(),
            }
            return this.http.postGeneric<any>(body, "AiServices/injest/userdoc",false,true).subscribe({
                next:(value)=>{
                    resolve(value);
                },
                error:(error)=>{
                    reject(error);
                }
            });
        });
    }

    updateDocumentationBase(agent: Agent, kb: KnowledgeBase): Promise<any> {

        return new Promise((resolve, reject) => {
            let body = {
                "agent":agent._id,
                "entityName": agent.kbTable,
                "kind": "userDocumentation",
                "file":{
                    "filePath": kb.filePath,
                    "fileName": kb.fileName,
                    "fileSize": kb.fileSize,
                    "mimeType": kb.mimeType
                },
                "version": new Date().getTime().toString(),
            }
            return this.http.postGeneric<any>(body, "AiServices/injest/userdoc",false,true).subscribe({
                next:(value)=>{
                    resolve(value);
                },
                error:(error)=>{
                    reject(error);
                }
            });
        });
    }


  /**
   * Download de arquivo
   */
    downloadKnowledgeBase(agent: Agent, fileId: string): Observable<Blob> {
        // return this.http.get(`/api/agents/${agentId}/kb/${fileId}/download`, {
        //   responseType: 'blob'
        // });
        return null;
    }

  /**
   * Deleta arquivo da base de conhecimento
   */
    deleteKnowledgeBase(file, agent:Agent): Observable<Object> {
        let body = {
            "entityName":agent.kbTable,
            "condition":`{
                "kind":"manual", 
                "agentId":{
                    "$oid":"${agent._id}"
                }, 
                "source":"${file.source}", 
                "version":"${file.version}",
                "kind":"${file.kind}"
            }`,
            "useMongo":true,
            "dbName": agent.dbName
        }
        return this.http.post(body,'JsonBrokerServices/remove',false,true,false,true);    
    }

    getQueryKB(agent:Agent){

        let query = `[
                {
                    $match: {
                        kind: "manual",
                        agentId: { '$oid': "${agent._id}" }
                    }
                },
                {
                    $group: {
                    _id: {source:"$source", kind: "$kind", status:"$status", version:"$version"},
                    chunks: {
                        $sum: 1
                    },
                    min_created_at:{
                        $min:"$created_at"
                    }
                    }
                },
                {
                    $project: {
                    _id:0,
                    source:"$_id.source",
                    kind:"$_id.kind",
                    status:"$_id.status",
                    version:"$_id.version",
                    chunks:"$chunks",
                    created_at:"$min_created_at"
                    }
                }
            ]`;

            return query;
    }

}
